export default "./dist/stdassets/images/icons/folder-horizontal-open.png";